import React, { useEffect, useState } from 'react';
import { SUPPLIER_PRODUCT_STATUSES_URL, getFetchRequest, postFetchRequest, putFetchRequest, deleteFetchRequest } from '../store/requests';
import { makeUrl, errorCallback } from '../constant';

const defaultFormData = {
    code: '',
    name: '',
    color: '',
    sort_order: 0,
    is_active: true,
    is_default: false,
};

const SupplierProductStatusesTab = ({ isCollapsed }) => {
    const [statuses, setStatuses] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [editingStatus, setEditingStatus] = useState(null);
    const [formData, setFormData] = useState(defaultFormData);

    const successGetStatusesCallback = (result) => {
        setStatuses(Array.isArray(result) ? result : []);
    };

    useEffect(() => {
        getFetchRequest(makeUrl([SUPPLIER_PRODUCT_STATUSES_URL]), successGetStatusesCallback, errorCallback);
    }, []);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleEdit = (status) => {
        setEditingStatus(status);
        setFormData({
            code: status.code || '',
            name: status.name || '',
            color: status.color || '',
            sort_order: status.sort_order ?? 0,
            is_active: status.is_active ?? true,
            is_default: status.is_default ?? false,
        });
        setIsEditing(true);
    };

    const handleNew = () => {
        setEditingStatus(null);
        setFormData({
            ...defaultFormData,
            sort_order: statuses.length,
        });
        setIsEditing(true);
    };

    const handleCancel = () => {
        setIsEditing(false);
        setEditingStatus(null);
        setFormData(defaultFormData);
    };

    const handleSave = () => {
        const successCallback = () => {
            getFetchRequest(makeUrl([SUPPLIER_PRODUCT_STATUSES_URL]), successGetStatusesCallback, errorCallback);
            handleCancel();
        };

        const payload = {
            code: formData.code,
            name: formData.name,
            color: formData.color || null,
            sort_order: Number(formData.sort_order) || 0,
            is_active: !!formData.is_active,
            is_default: !!formData.is_default,
        };

        if (editingStatus) {
            putFetchRequest(
                makeUrl([SUPPLIER_PRODUCT_STATUSES_URL, editingStatus.id, '/']),
                payload,
                successCallback,
                errorCallback,
            );
        } else {
            postFetchRequest(
                makeUrl([SUPPLIER_PRODUCT_STATUSES_URL]),
                payload,
                successCallback,
                errorCallback,
            );
        }
    };

    const handleDelete = (statusId) => {
        if (!window.confirm('Вы уверены, что хотите удалить этот статус?')) {
            return;
        }

        const successCallback = () => {
            getFetchRequest(makeUrl([SUPPLIER_PRODUCT_STATUSES_URL]), successGetStatusesCallback, errorCallback);
        };

        deleteFetchRequest(
            makeUrl([SUPPLIER_PRODUCT_STATUSES_URL, statusId, '/']),
            successCallback,
            errorCallback,
        );
    };

    const sortedStatuses = [...statuses].sort((a, b) => {
        const aOrder = typeof a.sort_order === 'number' ? a.sort_order : 0;
        const bOrder = typeof b.sort_order === 'number' ? b.sort_order : 0;
        return aOrder - bOrder;
    });

    if (isEditing) {
        return (
            <section
                className={`workspace ${
                    isCollapsed === null ? '' : isCollapsed ? 'workspace_collapsed' : 'workspace_full-width'
                } config__page`}
            >
                <h1 className="config__title">
                    {editingStatus ? 'Редактировать статус товара поставщика' : 'Создать статус товара поставщика'}
                </h1>

                <div className="banner__form">
                    <div className="banner__form-group">
                        <label className="banner__label">Код (латиница, для системы):</label>
                        <input
                            type="text"
                            name="code"
                            value={formData.code}
                            onChange={handleInputChange}
                            className="config__input"
                            placeholder="Например, ON_TRANSIT"
                            required
                        />
                    </div>

                    <div className="banner__form-group">
                        <label className="banner__label">Название (отображается в UI и у клиента):</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            className="config__input"
                            placeholder="Например, Поступил на транзитный склад"
                            required
                        />
                    </div>

                    <div className="banner__form-group">
                        <label className="banner__label">Цвет статуса (HEX, опционально):</label>
                        <input
                            type="text"
                            name="color"
                            value={formData.color}
                            onChange={handleInputChange}
                            className="config__input"
                            placeholder="#FF9800"
                            pattern="^#[0-9A-Fa-f]{6}$"
                        />
                    </div>

                    <div className="banner__form-group">
                        <label className="banner__label">Порядок отображения:</label>
                        <input
                            type="number"
                            name="sort_order"
                            value={formData.sort_order}
                            onChange={handleInputChange}
                            className="config__input"
                            min="0"
                        />
                    </div>

                    <div className="banner__form-group">
                        <label className="config__label banner__checkbox-label">
                            <input
                                type="checkbox"
                                name="is_active"
                                checked={!!formData.is_active}
                                onChange={handleInputChange}
                                className="config__checkbox"
                            />
                            Активен
                        </label>
                    </div>

                    <div className="banner__form-group">
                        <label className="config__label banner__checkbox-label">
                            <input
                                type="checkbox"
                                name="is_default"
                                checked={!!formData.is_default}
                                onChange={handleInputChange}
                                className="config__checkbox"
                            />
                            Статус по умолчанию
                        </label>
                        <p className="banner__hint">
                            При создании или добавлении позиций в заказ поставщика этот статус будет автоматически
                            присвоен новым строкам.
                        </p>
                    </div>

                    <div className="banner__form-actions">
                        <button onClick={handleSave} className="banner__btn banner__btn_save">
                            Сохранить
                        </button>
                        <button onClick={handleCancel} className="banner__btn banner__btn_cancel">
                            Отмена
                        </button>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section
            className={`workspace ${
                isCollapsed === null ? '' : isCollapsed ? 'workspace_collapsed' : 'workspace_full-width'
            } config__page`}
        >
            <div className="banner__header">
                <h1 className="config__title">Статусы товара поставщика</h1>
                <button onClick={handleNew} className="banner__btn banner__btn_new">
                    Создать статус
                </button>
            </div>

            <div className="banner__list">
                {sortedStatuses.length === 0 ? (
                    <p className="banner__empty">Статусы не найдены</p>
                ) : (
                    sortedStatuses.map((status) => (
                        <div
                            key={status.id}
                            className={`banner__item ${!status.is_active ? 'banner__item_inactive' : ''}`}
                        >
                            <div className="banner__item-content">
                                <h3 className="banner__item-title">{status.name}</h3>
                                <p className="banner__item-text">
                                    Код: <strong>{status.code}</strong>
                                </p>
                                <div className="banner__item-meta">
                                    <span>Порядок: {status.sort_order ?? 0}</span>
                                    <span>Статус: {status.is_active ? 'Активен' : 'Неактивен'}</span>
                                    {status.is_default && <span> · по умолчанию</span>}
                                </div>
                                {status.color && (
                                    <div className="banner__item-color">
                                        <span>Цвет: </span>
                                        <div
                                            style={{
                                                backgroundColor: status.color,
                                                width: '30px',
                                                height: '20px',
                                                display: 'inline-block',
                                                border: '1px solid #ccc',
                                                borderRadius: '3px',
                                                marginLeft: '4px',
                                            }}
                                        />
                                        <span> {status.color}</span>
                                    </div>
                                )}
                            </div>
                            <div className="banner__item-actions">
                                <button
                                    onClick={() => handleEdit(status)}
                                    className="banner__btn banner__btn_edit"
                                >
                                    Редактировать
                                </button>
                                <button
                                    onClick={() => handleDelete(status.id)}
                                    className="banner__btn banner__btn_delete"
                                >
                                    Удалить
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </section>
    );
};

export default SupplierProductStatusesTab;

